module.exports = __webpack_public_path__ + "static/wtf3-17d993cf03d3b120033544281a69c980.gif";